<template>
  <v-main
    style="
      max-width: 92%;
      width: 500px;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      height: 100%;
    "
  >
    <v-progress-circular
      indeterminate
      color="secondary"
      class="absolute-center"
    ></v-progress-circular>
  </v-main>
</template>

<script>
export default {
  props: ["auth", "routeNames"],
  created() {
    if (this.$route.query.nbResponse === "Aprobado") {
      this.$router.push({ name: this.routeNames.PAYMENT_SUCCESS });
    } else {
      this.$router.push({ name: this.routeNames.PAYMENT_ERROR });
    }
  },
};
</script>
